<template>
  <section>
    <b-row class="match-height">
      <b-col lg="12">
        <b-alert
          v-if="announcement !== undefined"
          show
          dismissible
          fade
          variant="success"
        >
          <div
            class="alert-body"
            v-html="announcement"
          />
        </b-alert>
      </b-col>
      <b-col
        v-if="helpDesk !== undefined"
        lg="12"
      >
        <help-desk-statistics
          :data="helpDeskStatistics"
        />
      </b-col>
      <b-col
        v-if="helpDesk !== undefined || salesOrder !== undefined"
        lg="8"
      >
        <recent-help-desk
          v-if="helpDesk !== undefined"
          :table-data="helpDesk"
          :fetch-data="fetchData"
        />
        <recent-sales-order
          v-if="salesOrder !== undefined"
          :table-data="salesOrder"
          :fetch-data="fetchData"
        />
      </b-col>
      <b-col
        v-if="helpDesk !== undefined || invoice !== undefined"
        lg="4"
      >
        <shortcuts v-if="helpDesk !== undefined" />
        <recent-invoice
          v-if="invoice !== undefined"
          :table-data="invoice"
          :fetch-data="fetchData"
        />
      </b-col>
    </b-row>
  </section>
</template>

<script>
import { BRow, BCol, BAlert } from 'bootstrap-vue'
import { coreMethods } from '@/mixins'
import api from '@/apis/portal'
import HelpDeskStatistics from './HelpDeskStatistics.vue'
import RecentInvoice from './RecentInvoice.vue'
import RecentHelpDesk from './RecentHelpDesk.vue'
import RecentSalesOrder from './RecentSalesOrder.vue'
import Shortcuts from './Shortcuts.vue'

export default {
  components: {
    BRow,
    BCol,
    BAlert,
    Shortcuts,
    HelpDeskStatistics,
    RecentInvoice,
    RecentSalesOrder,
    RecentHelpDesk,
  },
  mixins: [coreMethods],
  data() {
    return {
      fetchData: true,
      helpDeskStatistics: [],
      announcement: undefined,
      helpDesk: undefined,
      invoice: undefined,
      salesOrder: undefined,
    }
  },
  beforeMount() {
    this.createNavigationMenus()
    // data
    api.fetchAnnouncement().then(data => {
      this.announcement = data.announcement ? data.announcement : undefined
    })
    api.fetchRecentRecords().then(data => {
      this.fetchData = false
      this.helpDesk = data.HelpDesk ? data.HelpDesk : undefined
      this.invoice = data.Invoice ? data.Invoice : undefined
      this.salesOrder = data.SalesOrder ? data.SalesOrder : undefined
      if (this.helpDesk !== undefined) {
        api.helpDeskStatistics().then(helpDeskData => {
          const helpDeskStatistics = []
          const icons = [
            'DiscIcon',
            'FlagIcon',
            'GridIcon',
            'InfoIcon',
            'MessageCircleIcon',
          ]
          Object.keys(helpDeskData).forEach((status, index) => {
            helpDeskStatistics.push({
              icon: icons[index],
              color: helpDeskData[status].color,
              title: helpDeskData[status].count,
              subtitle: status,
              customClass: 'mb-2',
            })
          })
          this.helpDeskStatistics = helpDeskStatistics
        })
      }
    })
  },

  methods: {

  },
}
</script>

<style scoped>

</style>
